import * as _ from 'underscore';
import { ByteSizeConversionFactor } from '../filters/SizeFilter';
import { Module } from '../Module';

Module.instance().directive('tbBytesInputConverter',
  () => {
    return {
      restrict: 'A',
      require: 'ngModel',
       link: (scope: ng.IScope, elm: JQuery, attrs: ng.IAttributes, ctrl: ng.INgModelController) => {

        ctrl.$parsers.push((sizeInGigabytes: any): number => {
          // GB -> B
          const sizeInBytes = sizeInGigabytes * ByteSizeConversionFactor.ONE_GB;

          if (!isNaN(sizeInBytes) && sizeInBytes > 0 && _.isFinite(sizeInBytes)) {
            ctrl.$setValidity('bytes', true);
            return sizeInBytes;
          } else {
            ctrl.$setValidity('bytes', false);
            return 0;
          }
        });

        ctrl.$formatters.push((sizeInBytes: any): number => {
          // B -> GB
          if (!isNaN(sizeInBytes) && sizeInBytes > 0 && _.isFinite(sizeInBytes)) {
            return parseFloat((sizeInBytes / ByteSizeConversionFactor.ONE_GB).toFixed(3));
          } else {
            return sizeInBytes;
          }
        });
      }
    };
  }
);
